import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Button } from 'react-admin'

import Add from '@material-ui/icons/Add'

import { toggleGeneratePromoCodesModal } from '../../../redux/actions/modals'
import GeneratePromoCodesModal from '../modals/GeneratePromoCodesModal'

const GeneratePromoCodesAction = props => (
  <Fragment>
    <Button
      label='Create many'
      color='primary'
      onClick={props.toggleGeneratePromoCodesModal}
    >
      <Add />
    </Button>
    <GeneratePromoCodesModal record={props.record} />
  </Fragment>
)

export default connect(null, {
  toggleGeneratePromoCodesModal
})(GeneratePromoCodesAction)
